module.exports = __webpack_public_path__ + "static/fivePetals-c2c0324a3b2b04d623fdf399a17735ab.jpg";